<template>
  <div class="additional-setup">
    <div class="additional-setup__header">
      <v-icon color="primary" class="additional-setup__header-icon">mdi-tune-variant</v-icon>
      <h2 class="additional-setup__title">Дополнительные настройки</h2>
    </div>
    <v-row>
      <v-col cols="12" md="6" class="pb-0">
        <v-row>
          <v-col v-if="$checkPermission('update_code_main_setups') && control" cols="12" md="8" class="py-0">
            <v-text-field
              ref="adminCode"
              v-model="formOptionalSettings.adminCode"
              :rules="rules.adminCode"
              flat
              outlined
              dense
              label="Администраторский код"
              prepend-inner-icon="mdi-key"
              class="additional-setup__field"
            />
          </v-col>
          <v-col v-if="$checkPermission('update_code_main_setups') && control" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" dark rounded @click="changeAdminCode()">
              <v-icon left small>mdi-pencil</v-icon>
              Изменить
            </v-btn>
          </v-col>
          <v-col v-if="control" cols="12" md="6" class="py-0">
            <v-text-field
              ref="cHeatThresHold"
              v-model="formOptionalSettings.cHeatThresHold"
              :rules="rules.cHeatThresHold"
              flat
              outlined
              dense
              label="Контроль нагрева LCD"
              prepend-inner-icon="mdi-thermometer"
              class="additional-setup__field"
            />
          </v-col>
          <v-col v-if="control" cols="12" md="2" class="py-0 pt-1">
            <v-checkbox
              v-model="cHeatSwitch"
              :label="displayLabel(cHeatSwitch)"
              class="mt-0"
              hide-details
            />
          </v-col>
          <v-col v-if="control" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" dark rounded @click="changeHeating()">
              <v-icon left small>mdi-pencil</v-icon>
              Изменить
            </v-btn>
          </v-col>
          <v-col v-if="!control" cols="12" md="6" class="py-0">
              <v-select
                v-if="$checkPermission('get_dwdr') && doorphone.physical_status !== 6"
                ref="DWDRLevel"
                :items="DWDRLevels"
                v-model='formOptionalSettings.DWDRLevel'
                label="Контроль параметра DWDR"
                item-text="text"
                item-value="value"
                flat
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col v-if="!control" cols="2" class="py-0 pt-1">
              <v-checkbox
                v-if="$checkPermission('get_dwdr') && doorphone.physical_status !== 6"
                v-model='DWDR'
                :label="displayLabel(this.DWDR)"
                class="mt-0"
              >
              </v-checkbox>
            </v-col>
          <v-col v-if="!control" cols="12" md="4" class="py-0">
            <v-btn
              v-if="$checkPermission('set_dwdr') && doorphone.physical_status !== 6"
              color="primary"
              class="text-none"
              dark
              rounded
              @click="changeDWDR()"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Изменить
            </v-btn>
          </v-col>
          <v-col v-if="$checkPermission('upload_open_door_sound_doorphone') && doorphone.physical_status !== 6" cols="12" md="8" class="py-0">
            <v-file-input
              ref="soundDoor"
              v-model="formOptionalSettings.soundDoorOpening"
              accept=".wav"
              outlined
              dense
              flat
              label="Звук открытия двери"
              :rules="rules.sound"
              append-icon="mdi-information-outline"
              @click:append="infoSoundDoor = !infoSoundDoor"
            />
            <v-col v-if="infoSoundDoor" class="ml-5 pt-0">
              <p class="caption">Формат файла: wav. Размер: до 200 КБ.</p>
              <p class="caption">Частота дискретизации: 16000 Гц. Бит: 16</p>
            </v-col>
          </v-col>
          <v-col v-if="$checkPermission('upload_open_door_sound_doorphone') && doorphone.physical_status !== 6" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" dark rounded @click="changeSoundDoor()">
              <v-icon left small>mdi-upload</v-icon>
              Загрузить
            </v-btn>
          </v-col>
          <v-col v-if="$checkPermission('upload_ring_sound_doorphone') && doorphone.physical_status !== 6" cols="12" md="8" class="py-0">
            <v-file-input
              ref="soundBeep"
              v-model="formOptionalSettings.soundBeep"
              accept=".wav"
              outlined
              dense
              flat
              label="Звук гудка"
              :rules="rules.sound"
              append-icon="mdi-information-outline"
              @click:append="infoSoundBeep = !infoSoundBeep"
            />
            <v-col v-if="infoSoundBeep" class="ml-5 pt-0">
              <p class="caption">Формат файла: wav. Размер: до 200 КБ.</p>
              <p class="caption">Частота дискретизации: 16000 Гц. Бит: 16</p>
            </v-col>
          </v-col>
          <v-col v-if="$checkPermission('upload_ring_sound_doorphone') && doorphone.physical_status !== 6" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" dark rounded @click="changeSoundBeep()">
              <v-icon left small>mdi-upload</v-icon>
              Загрузить
            </v-btn>
          </v-col>
          <v-col v-if="$checkPermission('import_from_csv_keys_doorphone')" cols="12" md="8" class="py-0">
            <v-file-input
              ref="KeysDoorphone"
              v-model="formOptionalSettings.keysUpload"
              accept=".csv"
              outlined
              dense
              flat
              label="Ключи"
              :rules="rules.keys"
              append-icon="mdi-information-outline"
              @click:append="infoKeysUpload = !infoKeysUpload"
            />
            <v-col v-if="infoKeysUpload" class="ml-5 pt-0">
              <p class="caption">Формат файла: csv</p>
            </v-col>
          </v-col>
          <v-col v-if="$checkPermission('import_from_csv_keys_doorphone')" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" dark rounded @click="importKeys()">
              <v-icon left small>mdi-upload</v-icon>
              Загрузить
            </v-btn>
          </v-col>
          <v-col v-if="$checkPermission('set_card_status_keys') && showCardStatus" cols="12" md="8" class="py-0">
            <v-checkbox v-model="cardStatus" label="Автосбор ключей" class="mt-0" hide-details />
          </v-col>
          <v-col v-if="$checkPermission('set_card_status_keys') && showCardStatus" cols="12" md="4" class="py-0">
            <v-btn color="primary" class="text-none" rounded @click="saveCardStatus()">
              <v-icon left small>mdi-content-save-outline</v-icon>
              Сохранить
            </v-btn>
          </v-col>
          </v-row>
        </v-col>

      <v-dialog v-model="dialogErrors" max-width="550" content-class="dialog-border-radius">
        <v-card>
          <v-card-title class="headline">Ошибки при загрузке ключей</v-card-title>
          <v-card-text>
            <ul v-if="errorMessages.length">
              <li v-for="(error, index) in errorMessages" :key="index">
                {{ error }}
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" outlined rounded class="text-none" @click="dialogErrors = false">
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { HEAT_SWITCH_STATUS, rules } from '../../../consts';
import doorphone from '@/services/api/doorphone';

export default {
  name: 'AdditionalSetup',
  props: ['returnDoorphone'],
  data: () => ({
    infoSoundDoor: false,
    infoKeysUpload: false,
    infoSoundBeep: false,
    cardStatus: false,
    cHeatSwitch: null,
    DWDR: null,
    showCardStatus: false,
    rules,
    dialogErrors: false,
    errorMessages: [],
    formOptionalSettings: {
      cHeatThresHold: '',
      DWDRLevel: null,
      adminCode: '',
      soundDoorOpening: null,
      keysUpload: null,
      soundBeep: null,
    },
    DWDRLevels: [
      {
        value: 1,
        text: 'низкий',
      },
      {
        value: 2,
        text: 'средний',
      },
      {
        value: 3,
        text: 'высокий',
      },
    ],
  }),
  created () {
    this.loadAdminCodes(this.$route.params.id)
      .then(() => {
        this.formOptionalSettings.adminCode = this.adminCodes.adminCode;
      })
      .catch((err) => {
        console.error(err);
        if (err.response && err.response.status === 400) {
          const error = err.response.data.error;
          this.$flash_warning('Ошибка: ' + error);
        } else {
          this.$flash_warning('Произошла ошибка во время получения кодов');
        }
      });
    if (this.control) {
      this.heatingView(this.$route.params.id)
        .then(res => {
          this.heating = res;
          this.formOptionalSettings.cHeatThresHold = this.heating.cHeatThresHold;
          this.heating.cHeatSwitch === '0' ? this.cHeatSwitch = false : this.cHeatSwitch = true;
        });
    } else {
      this.dwdrView(this.$route.params.id)
        .then(res => {
          this.dwdr = res;
          this.formOptionalSettings.DWDRLevel = this.dwdr.dwdr_level;
          this.dwdr.dwdr ? this.DWDR = true : this.DWDR = false;
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Не удалось получить настройки изображения');
          }
        });
    }

    const firmwareVersion = this.doorphone.device?.firmware_version || null;
    if (firmwareVersion && parseInt(firmwareVersion.replace(/\./g, '')) > 227124339) {
      this.showCardStatus = true;
      this.loadCardStatus(this.$route.params.id)
        .then(res => {
          this.cardStatus = (this.keysStatus === '2');
        })
        .catch(() => this.$flash_warning('Не удалось определить статус автосбора ключей'));
    }
  },
  computed: {
    ...mapGetters({
      textmessage: 'Doorphone/textmessage',
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      adminCodes: 'MainSetups/adminCodes',
      keysStatus: 'Keys/cardStatus',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    displayDuplicate () {
      return (this.doorphone.type === 'M') && ((this.doorphone.additionalEntrances.length > 0) ||
        (this.doorphone.gates.length > 0));
    },
    control () {
      return this.doorphone && this.doorphone.manufacturer === 'Rubetek';
    },
  },
  methods: {
    ...mapActions({
      uploadRingsound: 'Doorphone/uploadRingsound',
      uploadDoorsound: 'Doorphone/uploadDoorsound',
      getTextMessage: 'Doorphone/getTextmessage',
      loadAdminCodes: 'MainSetups/getAdminCodes',
      editHeating: 'Doorphone/editHeating',
      editDWDR: 'Doorphone/editDWDR',
      heatingView: 'Doorphone/heatingView',
      dwdrView: 'Doorphone/dwdrView',
      updateAdminCode: 'MainSetups/updateAdminCode',
      loadCardStatus: 'Keys/getCardStatus',
      setCardStatus: 'Keys/setCardStatus',
    }),
    displayLabel (item) {
      return HEAT_SWITCH_STATUS[item];
    },
    changeAdminCode () {
      if (!this.$refs.adminCode.validate()) {
        this.$flash_warning('Заполните поле');
        return;
      }
      this.updateAdminCode({
        doorphoneId: this.doorphone.id,
        code: this.formOptionalSettings.adminCode,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.loadAdminCodes(this.$route.params.id).catch(() => {});
        })
        .catch(() => {
          this.$flash_warning('Ошибка при замене администраторского кода на домофоне');
        });
    },
    changeDWDR () {
      this.editDWDR({
        id: this.doorphone.id,
        DWDR: this.DWDR,
        DWDRLevel: this.formOptionalSettings.DWDRLevel,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при изменении контроля параметра DWDR');
        });
    },
    changeHeating () {
      if (this.$refs.cHeatThresHold.validate()) {
        this.editHeating({
          id: this.doorphone.id,
          cHeatSwitch: this.cHeatSwitch,
          cHeatThresHold: this.formOptionalSettings.cHeatThresHold,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при редактирование контроля нагрева LCD');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundDoor () {
      if (this.$refs.soundDoor.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundDoorOpening);

        this.uploadDoorsound({ id: this.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundDoorOpening = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundDoor.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука открытия двери');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    importKeys () {
      if (this.$refs.KeysDoorphone.validate()) {
        const formData = new FormData();
        formData.append('keys', this.formOptionalSettings.keysUpload);
        doorphone.uploadKeys(this.doorphone.id, formData)
          .then((response) => {
            if (response.data.errors && response.data.errors.length > 0) {
              this.errorMessages = response.data.errors;
              this.dialogErrors = true;
            }
            this.formOptionalSettings.keysUpload = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.KeysDoorphone.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при загрузке ключей');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundBeep () {
      if (this.$refs.soundBeep.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundBeep);

        this.uploadRingsound({ id: this.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundBeep = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundBeep.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука гудка');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    saveCardStatus () {
      const status = this.cardStatus ? 2 : 0;

      this.setCardStatus({ doorphoneId: this.doorphone.id, status })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Не удалось сохранить изменения');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-setup__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.additional-setup__header-icon {
  flex-shrink: 0;
}

.additional-setup__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.additional-setup__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}
</style>
